import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { getImageProps } from 'next/image';
import slideLeft from '@/public/images/redirect-slide-left.jpg';
import slideCenter from '@/public/images/redirect-slide-center.jpg';
import slideRight from '@/public/images/redirect-slide-right.jpg';

// The redirect buffer's three slides (components/RedirectBuffer.js), at the
// sizes it renders them, so they are cached before the hand-off shows them.
const {
  props: slideLeftProps
} = getImageProps({
  src: slideLeft,
  alt: '',
  fill: true,
  sizes: '241px'
});
const {
  props: slideCenterProps
} = getImageProps({
  src: slideCenter,
  alt: '',
  fill: true,
  sizes: '284px'
});
const {
  props: slideRightProps
} = getImageProps({
  src: slideRight,
  alt: '',
  fill: true,
  sizes: '241px'
});

/** Preloads the redirect buffer's slide images. */
function RedirectSlidePreload() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><link rel="preload" as="image" imageSrcSet={slideLeftProps.srcSet} imageSizes={slideLeftProps.sizes} fetchPriority="high" /><link rel="preload" as="image" imageSrcSet={slideCenterProps.srcSet} imageSizes={slideCenterProps.sizes} fetchPriority="high" /><link rel="preload" as="image" imageSrcSet={slideRightProps.srcSet} imageSizes={slideRightProps.sizes} fetchPriority="high" /></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default RedirectSlidePreload;